const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
};

// Get Filter Content list api
const getFilterContentApi = async (
    accessToken: string, // access token
    websiteId:string
): Promise<any> => {
    //get api list

    const url = `${baseURL}/get-custom-content-options/${websiteId}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

const AddFilterContentApi = async (
  website_id: string,
  title: string,
  accessToken?: string // access token
): Promise<any> => {
    
  const formData = new FormData();
  formData.append('website_id', website_id)
  formData.append('title', title)
  formData.append('description', "test")
  formData.append('type', "test")
  formData.append('tag', "test")
  const url = `${baseURL}/custom-content-option`
  try {
    // add API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

const UpdateFilterContentApi = async (
  id:number,
  website_id: string,
  title: string,
  accessToken?: string // access token
): Promise<any> => {
    
  const formData = new FormData();
  formData.append('website_id', website_id)
  formData.append('id', id.toString())
  formData.append('title', title)
  formData.append('description', "test")
  formData.append('type', "test")
  formData.append('tag', "test")
  const url = `${baseURL}/custom-content-option`
  try {
    // add API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

const deleteFilterContentApi = async (
    accessToken: string, // access token
    defaultId: number
): Promise<any> => {
    
  const formData = new FormData();
  const url = `${baseURL}/delete-custom-content-option/${defaultId}`
  try {
    // delete API
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

export { getFilterContentApi, AddFilterContentApi, deleteFilterContentApi, UpdateFilterContentApi }